import { Button, FormControl, FormLabel, Grid, Icon, Stack } from '@mui/material'

import moment from 'moment'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'

import { useEffect, useRef, useState } from 'react'

import { useSelector } from 'react-redux'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useSingleSelector } from '@components/SingleSelector/use'
import { useTextinput } from '@components/Textinput/use'
import { AZURE, useLandingZones } from '@features/hooks/LandingZones'
import { FIREWALL, NSGFLOW, useLogsFirewall } from '@features/hooks/firewall'

import SingleSelector from '@components/SingleSelector'
import Tile from '@components/Tile'
import Textinput from '@components/Textinput'

import theme from '@services/theme'
import { scrollToTop } from '@services/utils'

export const Filters = (props) => {
    const dataStoreLZ = useSelector(state => state.landingZones)

    const { load: loadLz, getProvider, getFilterList } = useLandingZones()
    const { search, reset } = useLogsFirewall()
    const { show: showSnackbar } = useAppSnackbar()

    const [startDateValue, setStartDateValue] = useState(moment().subtract(15, 'minutes'))
    const [endDateValue, setEndDateValue] = useState(moment())
    const [categoryDisplayed, setCategoryDisplayed] = useState(true)
    const [categoryDisabled, setCategoryDisabled] = useState(false)
    const [selectLzError, setSelectLzError] = useState(false)
    const [disabledSearch, setDisabledSearch] = useState(true)
    const [lzLoading, setLzLoading] = useState(true)
    const [availableRegions, setAvailableRegions] = useState([{id: 'all', label: 'All'}])
    const currentProvider = useRef(null)

    const regions = useRef({
        azure: [
            {id: 'all', label: 'All'},
            {id: 'separator', label: '--'},
            {id: 'frc', label: 'Frc'},
            {id: 'eun', label: 'Eun'},
            {id: 'euw', label: 'Euw'},
            {id: 'swc', label: 'Swc'}
        ],
        aws: [
            {id: 'eu-central-1', label: 'EU central 1'},
            {id: 'eu-west-1', label: 'EU west 1'},
            {id: 'us-east-1', label: 'US east 1'}
        ]
    })

    const { selection: selectionLZ, computeSelection: computeSelectionLZ, onSelect: onSelectLZ, selected: selectedLZ } = useSingleSelector(getFilterList((props.mode === NSGFLOW) ? AZURE : null))

    const { selection: selectionRegion, computeSelection: computeSelectionRegion, onSelect: onSelectRegion, selected: selectedRegion } = useSingleSelector(availableRegions)

    const { selection: selectionAction, computeSelection: computeSelectionAction, onSelect: onSelectAction, selected: selectedAction } = useSingleSelector(
        [
            {id: 'all', label: 'All'},
            {id: 'separator', label: '--'},
            {id: 'allow', label: 'Allow'},
            {id: 'deny', label: 'Deny'}
        ]
    )

    const { selection: selectionCategory, computeSelection: computeSelectionCategory, onSelect: onSelectCategory, selected: selectedCategory } = useSingleSelector(
        [
            {id: 'all', label: 'All'},
            {id: 'separator', label: '--'},
            {id: 'AZFWApplicationRule', label: 'AZFWApplicationRule'},
            {id: 'AZFWNetworkRule', label: 'AZFWNetworkRule'}
        ]
    )

    const { selection: selectionDirection, computeSelection: computeSelectionDirection, onSelect: onSelectDirection, selected: selectedDirection } = useSingleSelector(
        [
            {id: 'all', label: 'All'},
            {id: 'separator', label: '--'},
            {id: 'Inbound', label: 'Inbound'},
            {id: 'Outbound', label: 'Outbound'}
        ]
    )

    const { selection: selectionProtocol, computeSelection: computeSelectionProtocol, onSelect: onSelectProtocol, selected: selectedProtocol } = useSingleSelector(
        [
            {id: 'all', label: 'All'},
            {id: 'separator', label: '--'},
            {id: 'http', label: 'HTTP'},
            {id: 'https', label: 'HTTPS'},
            {id: 'tcp', label: 'TCP'},
            {id: 'udp', label: 'UDP'}
        ]
    )

    const { value: typeValue, onChange: onChangeTypeValue, onReset: onResetType } = useTextinput()
    const { value: sourceValue, onChange: onChangeSourceValue, onReset: onResetSource } = useTextinput()
    const { value: sourcePortValue, onChange: onChangeSourcePortValue, onReset: onResetSourcePort } = useTextinput()
    const { value: targetValue, onChange: onChangeTargetValue, onReset: onResetTarget } = useTextinput()
    const { value: targetPortValue, onChange: onChangeTargetPortValue, onReset: onResetTargetPort } = useTextinput()

    useEffect(() => {
        if (!(dataStoreLZ.formated.mode > -1)) loadLz()

        computeSelectionLZ()
        computeSelectionRegion('all')
        computeSelectionDirection('all')
        computeSelectionAction('all')
        computeSelectionCategory('all')
        computeSelectionProtocol('all')
    }, [])

    useEffect(() => {
        if (!selectedLZ) return

        setSelectLzError(false)
        setDisabledSearch(false)

        const provider = getProvider(selectedLZ)

        if (!provider) return setAvailableRegions([])

        currentProvider.current = provider
        setAvailableRegions(regions.current[provider])

        if (((provider === AZURE) && props.mode === 'firewall')) {
            setCategoryDisabled(false)
        }
        else {
            setCategoryDisabled(true)
            computeSelectionCategory('all')
        }
    }, [selectedLZ])

    useEffect(() => {
        if (!currentProvider.current) return

        const provider = currentProvider.current

        if (provider === AZURE && props.mode === 'firewall') {
            computeSelectionRegion('all')
        } else if (provider) {
            computeSelectionRegion('eu-central-1')
        }
    }, [availableRegions])

    useEffect(() => {
        if (props.mode === NSGFLOW) {
            setAvailableRegions(regions.current[AZURE])
            setCategoryDisplayed(false)
        }

        if (dataStoreLZ.formated.mode < 1) return

        setLzLoading(false)
    }, [dataStoreLZ.formated.mode])

    const handleReset = () => {
        setSelectLzError(false)
        setDisabledSearch(false)

        computeSelectionRegion('all')
        computeSelectionAction('all')
        computeSelectionCategory('all')
        computeSelectionDirection('all')
        computeSelectionProtocol('all')

        if (props.mode === NSGFLOW) setAvailableRegions(regions.current[AZURE])

        onResetType()
        onResetSource()
        onResetSourcePort()
        onResetTarget()
        onResetTargetPort()

        setStartDateValue(moment().subtract(15, 'minutes'))
        setEndDateValue(moment())

        reset()

        scrollToTop()
    }

    const handleSearch = () => {
        if (!selectedLZ) {
            setSelectLzError(true)
            setDisabledSearch(true)
            return showSnackbar('You need to choose a Landing-Zone to request', 'info', 3000)
        }

        setSelectLzError(false)
        setDisabledSearch(false)

        const defaultSearch = {
            region: selectedRegion,
            action: selectedAction,
            from: startDateValue.format('YYYY-MM-DD HH:mm'),
            to: endDateValue.format('YYYY-MM-DD HH:mm'),
            source: sourceValue,
            target: targetValue,
            targetPort: parseInt(targetPortValue)
        };

        (props.mode === FIREWALL)
            ? search(selectedLZ, {
                ...defaultSearch,
                ...{category: selectedCategory, sourcePort: parseInt(sourcePortValue)}
            })
            : search(selectedLZ, {
                ...defaultSearch,
                ...{type: typeValue, protocol: selectedProtocol, direction: selectedDirection}
            }, null, NSGFLOW)
    }

    return (
        <Tile id={'filters'} sx={{border: 0, borderRadius: 0, borderBottom: `1px solid ${theme.palette.Tile.primary.border}`}} label={'Filters'} actions={(
            <Stack direction={'row'} spacing={1}>
                <Button variant={'secondary'} startIcon={<Icon>reset_settings</Icon>} onClick={handleReset}>Reset</Button>
                <Button variant={'primary'} startIcon={<Icon>search</Icon>} onClick={handleSearch} disabled={disabledSearch}>Launch search</Button>
            </Stack>
        )}>
            <Grid container spacing={2} alignItems={'center'} justifyContent={'center'}>
                <Grid>
                    <SingleSelector
                        loadingLabel={'LOADING LANDING-ZONES'}
                        loading={lzLoading}
                        error={selectLzError}
                        errorLabel={'Choose a Landing-Zone'}
                        variant={'secondary'}
                        label={'Landing zone'}
                        selection={selectionLZ}
                        onSelect={onSelectLZ}
                        selected={selectedLZ}
                    />
                </Grid>
                <Grid>
                    <SingleSelector
                        variant={'secondary'}
                        label={'Region'}
                        selection={selectionRegion}
                        onSelect={onSelectRegion}
                        selected={selectedRegion}
                    />
                </Grid>
                {(props.mode === NSGFLOW) && (
                    <Grid>
                        <SingleSelector
                            variant={'secondary'}
                            label={'Direction'}
                            selection={selectionDirection}
                            onSelect={onSelectDirection}
                            selected={selectedDirection}
                        />
                    </Grid>
                )}
                <Grid>
                    <SingleSelector
                        variant={'secondary'}
                        label={'Action'}
                        selection={selectionAction}
                        onSelect={onSelectAction}
                        selected={selectedAction}
                    />
                </Grid>
                {categoryDisplayed && (
                    <Grid>
                        <SingleSelector
                            disabled={categoryDisabled}
                            variant={'secondary'}
                            label={'Category'}
                            selection={selectionCategory}
                            onSelect={onSelectCategory}
                            selected={selectedCategory}
                        />
                    </Grid>
                )}
                <Grid>
                    <FormControl>
                        <FormLabel variant={'primary'}>From</FormLabel>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DateTimePicker
                                inputFormat={'YYYY/MM/DD H:i'}
                                format={'L HH:mm'}
                                value={startDateValue}
                                onChange={(newValue) => setStartDateValue(newValue)}
                                sx={{
                                    ['& .MuiPickersInputBase-root']: {
                                        height: '40px !important',
                                        background: theme.palette.SingleSelect.secondary.background
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid>
                    <FormControl>
                        <FormLabel variant={'primary'}>To</FormLabel>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DateTimePicker
                                inputFormat={'YYYY/MM/DD H:i'}
                                format={'L HH:mm'}
                                value={endDateValue}
                                onChange={(newValue) => setEndDateValue(newValue)}
                                sx={{
                                    ['& .MuiPickersInputBase-root']: {
                                        height: '40px !important',
                                        background: theme.palette.SingleSelect.secondary.background
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                {(props.mode === NSGFLOW) && (
                    <Grid>
                        <SingleSelector
                            variant={'secondary'}
                            label={'Protocol'}
                            selection={selectionProtocol}
                            onSelect={onSelectProtocol}
                            selected={selectedProtocol}
                        />
                    </Grid>
                )}
                {(props.mode === NSGFLOW) && (
                    <Grid>
                        <Textinput
                            variant={'secondary'}
                            label={'Type'}
                            field={{
                                value: typeValue,
                                onReset: onResetType,
                                onChange: onChangeTypeValue,
                                onKeyUp: onChangeTypeValue,
                                placeholder: 'InterVNet, MaliciousFlow...'
                            }}
                        />
                    </Grid>
                )}
                <Grid>
                    <Textinput
                        variant={'secondary'}
                        label={'Source'}
                        field={{
                            value: sourceValue,
                            onReset: onResetSource,
                            onChange: onChangeSourceValue,
                            onKeyUp: onChangeSourceValue,
                            placeholder: 'IP or CIDR-notation address'
                        }}
                    />
                </Grid>
                {(props.mode === FIREWALL) && (
                    <Grid>
                        <Textinput
                            variant={'secondary'}
                            label={'Source port'}
                            field={{
                                type: 'number',
                                value: sourcePortValue,
                                onReset: onResetSourcePort,
                                onChange: onChangeSourcePortValue,
                                onKeyUp: onChangeSourcePortValue,
                                placeholder: '0 to 65535'
                            }}
                        />
                    </Grid>
                )}
                <Grid>
                    <Textinput
                        variant={'secondary'}
                        label={'Target'}
                        field={{
                            value: targetValue,
                            onReset: onResetTarget,
                            onChange: onChangeTargetValue,
                            onKeyUp: onChangeTargetValue,
                            placeholder: 'FQDN, IP or CIDR-notation address'
                        }}
                    />
                </Grid>
                <Grid>
                    <Textinput
                        variant={'secondary'}
                        label={'Target port'}
                        field={{
                            type: 'number',
                            value: targetPortValue,
                            onReset: onResetTargetPort,
                            onChange: onChangeTargetPortValue,
                            onKeyUp: onChangeTargetPortValue,
                            placeholder: '0 to 65535'
                        }}
                    />
                </Grid>
            </Grid>
        </Tile>
    )
}

export default Filters